// Type
import type { ReactNode } from 'react';

import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import type { HEX } from '@/types/utils/colorsType';

import PropTypes from 'prop-types';

import type { DropdownProps } from '@/components/base/Dropdown';
import Dropdown from '@/components/base/Dropdown';
// Component
import Icon from '@/components/base/Icon';

type FilterProp = {
    name: string;
    color?: HEX;
    [key: string]: unknown;
};

type DropdownFilterProps = Omit<DropdownProps, 'button' | 'children'> & {
    buttonContent?: ReactNode | string;
    buttonClassName?: string;
    currentFilter: FilterProp;
    filters: FilterProp[];
    setFilter: (args: FilterProp) => void;
};

export const DropDownFilter = ({
    currentFilter,
    filters,
    setFilter,
    className,
    buttonContent,
    buttonClassName = 'text-sm',
    ...restProps
}: DropdownFilterProps) => {
    const { t } = useTranslation();
    return (
        <Dropdown
            button={
                <Dropdown.Button
                    data-testid="dropdown-filter-button"
                    className={clsx(
                        'inline-flex max-w-max items-center space-x-1 rounded-m px-0.5 py-1 focus:ring-offset-0',
                        buttonClassName
                    )}
                    name="dropdown-button">
                    {buttonContent ? (
                        buttonContent
                    ) : (
                        <span className="block text-left">{t(currentFilter?.name)}</span>
                    )}
                    <Icon
                        icon="chevron-bottom"
                        className={clsx(
                            'relative inline-block text-icoBlue transition-transform',
                            className ?? 'text-xs'
                        )}
                    />
                </Dropdown.Button>
            }
            {...restProps}>
            <div className="w-full space-y-0.5 overflow-hidden rounded-md p-0.5">
                {filters?.map((filter, index) => (
                    <Dropdown.Item
                        key={index}
                        onClick={() => setFilter(filter)}
                        className={clsx(
                            'flex w-full cursor-pointer items-center space-x-2 rounded-m p-2 text-left hover:bg-icoBlue-100 hover:dark:bg-icoBlue/20',
                            {
                                'bg-icoBlue-100 text-icoBlue dark:bg-icoBlue/20':
                                    currentFilter?.name === filter?.name
                            }
                        )}>
                        {filter?.color ? (
                            <span
                                className="block h-2 w-2 rounded-full"
                                style={{ backgroundColor: filter?.color }}
                            />
                        ) : null}
                        <span>{t(filter?.name)}</span>
                    </Dropdown.Item>
                ))}
            </div>
        </Dropdown>
    );
};

DropDownFilter.propTypes = {
    currentFilter: PropTypes.object,
    filters: PropTypes.array,
    setFilter: PropTypes.func,
    size: PropTypes.string,
    className: PropTypes.string,
    buttonContent: PropTypes.any,
    position: PropTypes.string
};
